import { Button, Stack, TextField } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import DHBackdrop from '../generic/dh-backdrop';
import { Controller, useForm } from 'react-hook-form';
import PasswordLessAuthService from '../../core/service/passwordless-service';
import { useSnackbar } from 'notistack';
import { IAppDetails } from '../../core/interface/general/IGeneral';
import AppContext, { AppContextType } from '../../core/context/auth-context';
import AuthLayout from '../generic/auth-layout';

const SmsVerifyComponent = () => {
    const {state} = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [loader, setLoader] = useState<boolean>(false);
    const {setAppContext} = useContext(AppContext) as AppContextType;
    const passwordLessAuthService = new PasswordLessAuthService();
    const defaultData = {
        smsCode: ""
    };
    const {
        handleSubmit,
        control,
    } = useForm({
        defaultValues: defaultData,
    });

    const onSubmit = async (loginData: any) => {
        setLoader(true);
        try {
            const data: any = await passwordLessAuthService.confirmSignIn(loginData.smsCode, state.nextStep.signInStep);
            if(data.nextStep?.additionalInfo?.challengeType === 'SMS') {
              enqueueSnackbar('Invalid SMS code', {variant: 'error'});
            } else {
              const tokens = await passwordLessAuthService.getTokens();
              sessionStorage.clear();
              sessionStorage.setItem('token', tokens.idToken!);
              setAppContext((prevState: IAppDetails) => ({
                ...prevState,
                ...{ isLoggedIn: true, authToken: tokens.idToken, refreshToken: tokens.idToken }
              }));
              navigate("/console");
              setLoader(false);
            }
        } catch (error) {
        } finally {
            setLoader(false);
        }
    };

    return (
        <React.Fragment>
          {loader && <DHBackdrop></DHBackdrop>}
          <AuthLayout
            title="Verify your phone"
            subtitle="Enter the code we sent to your phone by SMS."
          >
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Stack spacing={2.5}>
                <Controller
                  name="smsCode"
                  control={control}
                  rules={{
                    required: "This is required",
                    minLength: { value: 6, message: "This is not a valid code" },
                  }}
                  render={({
                    field: { ref, ...field },
                    fieldState: { invalid, error },
                  }) => (
                    <TextField
                      fullWidth
                      autoFocus
                      required
                      label="SMS code"
                      {...field}
                      inputRef={ref}
                      error={invalid}
                      helperText={error?.message}
                    />
                  )}
                />
                <Button type="submit" variant="contained" size="large" fullWidth>
                  Verify
                </Button>
              </Stack>
            </form>
          </AuthLayout>
        </React.Fragment>
      );
}

export default SmsVerifyComponent;
